import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await authAPI.me();
        setClub(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('club');
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { token, club: clubData, is_admin } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('club', JSON.stringify({ ...clubData, is_admin }));
    setClub({ ...clubData, is_admin });
    setIsAuthenticated(true);
    return { ...clubData, is_admin };
  };

  const register = async (data) => {
    const response = await authAPI.register(data);
    const { token, club: clubData } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('club', JSON.stringify(clubData));
    setClub(clubData);
    setIsAuthenticated(true);
    return clubData;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('club');
    setClub(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ 
      club, 
      loading, 
      isAuthenticated, 
      login, 
      register, 
      logout,
      checkAuth 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
